'use strict';

angular.module('ClinicApp').directive('clinicInHouseMembership', (OCValidationUtil, OCFormUtil) => {
  return {
    scope: {
      inHouseMembership: '=',
      editMode: '=',
      onStartEdit: '&',
      onSave: '&',
      onCancel: '&',
    },
    templateUrl: '/views/directives/_clinic-in-house-membership.html',
    link: function($scope) {
      const initialize = () => {
        const inHouseMembership = $scope.inHouseMembership || {};

        $scope.isConfigured = OCValidationUtil.isWholeDollarAmount(inHouseMembership.minPrice);

        // Fields stay unmarked until the practice has tried to save at least once.
        $scope.isSubmitted = false;

        $scope.form = {
          minPrice: $scope.isConfigured ? inHouseMembership.minPrice : null,
          maxPrice: inHouseMembership.maxPrice ?? null,
          url: inHouseMembership.url ?? null,
        };
      };

      $scope.$watch('inHouseMembership', initialize);

      /**
       * A single plan is priced with the minimum alone, so the maximum stays optional.
       */
      $scope.isMinPriceValid = () => OCValidationUtil.isWholeDollarAmount($scope.form.minPrice);

      $scope.isMaxPriceValid = () => {
        const { minPrice, maxPrice } = $scope.form;

        if (maxPrice === null || maxPrice === undefined || maxPrice === '') {
          return true;
        }

        return OCValidationUtil.isWholeDollarAmount(maxPrice)
          && (!OCValidationUtil.isWholeDollarAmount(minPrice) || maxPrice >= minPrice);
      };

      $scope.isUrlValid = () => !$scope.form.url || OCValidationUtil.isValidWebsite($scope.form.url);

      $scope.hasMinPriceError = () => $scope.isSubmitted && !$scope.isMinPriceValid();

      $scope.hasMaxPriceError = () => $scope.isSubmitted && !$scope.isMaxPriceValid();

      $scope.hasUrlError = () => $scope.isSubmitted && !$scope.isUrlValid();

      $scope.isSaveDisabled = () => !!$scope.isSaving;

      $scope.save = () => OCFormUtil.submit($scope, () => {
        // Keep the panel open with the errors shown rather than sending what the API would reject.
        if (!$scope.isMinPriceValid() || !$scope.isMaxPriceValid() || !$scope.isUrlValid()) {
          return;
        }

        const { minPrice, maxPrice, url } = $scope.form;

        return $scope.onSave({
          inHouseMembership: {
            minPrice,
            maxPrice: OCValidationUtil.isWholeDollarAmount(maxPrice) ? maxPrice : null,
            url: url ? OCValidationUtil.urlFormat(url) : null,
          },
        });
      });

      $scope.cancel = () => {
        initialize();
        return $scope.onCancel();
      };

      $scope.startEdit = () => {
        $scope.isSubmitted = false;
        return $scope.onStartEdit();
      };
    },
  };
});
